// Headings tesseract's automatic page layout skips (Bug2 follow-up): large text standing alone is often taken for a
// picture. A second reading in "sparse text" mode finds it; its lines are added where the first reading found nothing.
import type { Line } from 'tesseract.js';

/** Words added from the sparse reading need at least this confidence (0–100): elsewhere it also "reads" pictures. */
const MIN_CONFIDENCE = 60;

type Box = { x0: number; y0: number; x1: number; y1: number };
const overlap = (a: Box, b: Box) => Math.max(0, Math.min(a.x1, b.x1) - Math.max(a.x0, b.x0)) * Math.max(0, Math.min(a.y1, b.y1) - Math.max(a.y0, b.y0));
const area = (a: Box) => (a.x1 - a.x0) * (a.y1 - a.y0);

/**
 * The first reading's lines, then the sparse reading's lines cut down to their words that lie where the first found no
 * word (overlapping none by more than a fifth of the smaller box) and are read with some confidence; lines left with no
 * word are dropped.
 */
export function addSparseLines(main: Line[], sparse: Line[]): Line[] {
  const seen = main.flatMap((l) => l.words).filter((w) => w.text.trim()).map((w) => w.bbox);
  const added = sparse.flatMap((l) => {
    const words = l.words.filter((w) => w.text.trim() && w.confidence >= MIN_CONFIDENCE && !seen.some((b) => overlap(b, w.bbox) > 0.2 * Math.min(area(b), area(w.bbox))));
    return words.length ? [{ ...l, words, text: words.map((w) => w.text).join(' ') }] : [];
  });
  return [...main, ...added];
}
